import styled from "styled-components";
import { Button } from "src/components";


export const QuestionListContainer = styled.div`
  width: 100%;
  max-width: 361px;
  display: flex;
  align-items: flex-start;
  border: 1px solid ${(props) => props.theme.colors.disabledMeatballItem};
  border-radius: 5px;
  overflow: hidden;
  padding: 16px 8px 16px 16px;
`;

export const QuestionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 8px;
  padding-right: 8px;
  overflow-y: scroll;

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.disabledMeatballItem};
    border-radius: 10px;
  }
`;

export const QuestionListTitle = styled.h2`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px 0;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 16px;
`;

export const CheckboxButton = styled(Button)`
  cursor: pointer;
  height: 20px;
  width: 20px;
  background-color: transparent;
  padding: 2px 0;

  &:hover {
    background-color: transparent;
    color: transparent;
  }
`;

export const Square = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 2.28571px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : 'transparent'};
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 9px;
    width: 1.6px;
    background: ${props.theme.colors.backgroundColorPage};
  }

  :after {
    transform: rotate(45deg);
    left: 8px;
    top: 3px;
  }
  :before {
    height: 6px;
    transform: rotate(-45deg);
    left: 4px;
    top: 5px;
  }
  `
      : ""}
`;

export const CheckboxLabel = styled.label`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;